import $ from 'jquery';

global.$ = global.jQuery = $;
import 'cookieconsent';
//import 'bootstrap-sass';
import 'bootstrap';
import 'popper.js';


import common from './common/common';
import modal from './modules/modal';
import comparator from './vehicle/comparator';
import favorite from './vehicle/favorite';
import miniSearchForm from './app/mini-search-form';
import modalFunding from "./modules/modal-infos-funding";

function initOnHoverNav() {
    //ouvrir le megamenu au survol
    const navDropdowns = document.querySelectorAll('.nav-item.has-megamenu:not(.no-hover-dropdown)');

    const hoverHandler = (e) => {
        if (window.matchMedia("(min-width: 992px)").matches) {
            if (e.type === 'mouseenter') {
                e.currentTarget.querySelector('.megamenu').classList.add('show');

            } else {
                e.currentTarget.querySelector('.megamenu').classList.remove('show');
            }
        }
    };

    "mouseenter mouseleave".split(" ").forEach(function(e){
        navDropdowns.forEach(item => {
            item.addEventListener(e, hoverHandler, false);
        })
    });

    //fermé le megamenu au survol de l'overlay
    if (window.matchMedia("(min-width: 992px)").matches) {
        Array.from(document.querySelectorAll('.header .overlay'), itm => {
            // console.log(itm);
            itm.addEventListener('mouseenter', e => {
                Array.from(document.querySelectorAll('.megamenu'), itm => {
                    itm.classList.remove('show');
                })
            });
        });
    }
}

function initTopHeaderTelAnchor() {
 const telAnchor = $('#top-header-contact-tel');
 if (telAnchor) {
     telAnchor.on('click', function(e) {
         e.preventDefault();
        if (window.matchMedia("(min-width: 992px)").matches) {
            const path = $(telAnchor).data('contactpath');
            if (path) {
                window.location.href = path;
            }
        } else {
            const tel = $(telAnchor).data('tel');
            console.log(tel);
            if (tel) {
                window.open(tel);
            }
        }
     });
 }
}

function initModaleFoire() {

    var modal = $('#myModalBonneAnne');
    var now = (new Date()).getTime();
    var lastShowModal = localStorage.getItem('lastModalBonneAnne');
    var startDate = (new Date('2023/12/25')).getTime();
    var expirationDate = (new Date('2024/01/03')).getTime();

    if ((null === lastShowModal || now > parseInt(lastShowModal) + 86400000) && (now < expirationDate && now > startDate) ) {
        modal.modal('show');
        localStorage.setItem('lastModalBonneAnne', now);
    }
    if (now > expirationDate) {
        localStorage.removeItem('lastModalBonneAnne');
    }

}

// Global ready
$(document).ready(function () {
    console.log('global');
    common();
    initModaleFoire();
    modalFunding();
    comparator();
    favorite();
    miniSearchForm();
    initOnHoverNav();
    initTopHeaderTelAnchor();
    // Ouverture de la modal en dehors du carrousel de la HP
    $('.modal').appendTo("body");

    // Gestion de l'affichage du ssMenu principal dans le HEADER
    $('.main-menu__links--dropdown').on("click.bs.dropdown", function (e) {
        $('.main-menu-dropdown-menu-right').toggle();
    });
    $('.navbar .nav-link').on("click.bs.dropdown", function (e) {
        $('.main-menu-dropdown-menu-right').hide();
    });
    $('.cd-main-content, ' +
        '.main-menu__actions, ' +
        '.main-menu__links--phone, ' +
        '.block-makers-monochrome, ' +
        'footer').on("click", function (e) {
        $('.main-menu-dropdown-menu-right').hide();
    });

    // Gestion du "rotate" de l'icone
    $('.navbar .dropdown.megamenu-li a').on("click", function (e) {
        $(this).find('i').toggleClass('icon-chevron-circle-down icon-chevron-circle-up');
    });

    $('[data-toggle="popover"]').popover({
        html: true,
        trigger: 'hover'
    });
});



// WEBPACK FOOTER //
// ./app/Resources/assets/default/js/app.js